import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../store/store';
import { tenantSelector } from '../selector/authenticationSelector';
import AccountClosedPage from '../pages/common/AccountClosedPage';
import { showsAccountClosed } from '../utils/tenantArchived';

/**
 * #1379: the account was closed by its owner. Any request that met the
 * `tenant_archived` refusal raised the flag (store/tenantArchivedMiddleware);
 * this replaces the whole app with "This account has been closed", so no
 * screen shows a generic error or an empty list instead.
 */
const AccountClosedGate = ({ children }: { children: ReactNode }) => {
    const closedTenant = useSelector((state: RootState) => state.global.closedTenant);
    const tenant = useSelector(tenantSelector);
    return showsAccountClosed(closedTenant, tenant) ? <AccountClosedPage /> : <>{children}</>;
};

export default AccountClosedGate;
